var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");

var PathToolStateMachine = require("./pathToolStateMachine.js");
var AbstractToolController = require("./../../../extensions/abstractToolController.js");

var PathToolController = function(archLayers, dependencies, configuration) {
    this.setDefaultConfiguration({
        flip: 1,
        fill: false,
        strokeWidth: 2,
        PathClass: cio_datamodel.PathData,
        stateMachineMode : cio_datamodel.PathPointMode.STRAIGHT
    });

    AbstractToolController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(PathToolController, AbstractToolController);
PathToolController.inject = AbstractToolController.inject;
PathToolController.StateMachineClass = PathToolStateMachine;

module.exports = PathToolController;

PathToolController.prototype.getButtonElements = function () {
    var buttonElements = {
        name: 'Pen',
        title: 'Path',
        style: {
            icon: 'icon-pen.svg',
        },
        eventData: {
            "tool": this.name()
        },
        auto_escape: true
    };

    return buttonElements;
};
